import { Form, Input, Select, DatePicker, Switch, Button, Card, Row, Col, message, Space, Table } from 'antd';
import AdminSidebar from '../Components/Sidebar';
import { useNavigate } from 'react-router';
import TableComponent from '../Components/TableComponent';
import { getTransactionList } from '../redux/slices/transactionSlice';
import { getProvidersList } from '../redux/slices/adminSlice';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const { RangePicker } = DatePicker;

function TransactionList() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [dateRange, setDateRange] = useState(null);
    const [selectedProvider, setSelectedProvider] = useState(null);
    const [totalAmount, setTotalAmount] = useState(0);
    const { providersList } = useSelector((state) => state?.admin);

    useEffect(() => {
        dispatch(getProvidersList({ page: 1, limit: 1000 }))
    }, [dispatch]);

    // Fetch total amount for all filtered transactions
    useEffect(() => {
        const fetchTotalAmount = async () => {
            let params = {
                page: 1,
                limit: 10000 // High limit to get all filtered transactions
            };

            if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
                params.start_date = dateRange[0].format('YYYY-MM-DD');
                params.end_date = dateRange[1].format('YYYY-MM-DD');
            }

            if (selectedProvider) {
                params.provider_id = selectedProvider;
            }

            try {
                const result = await dispatch(getTransactionList(params));
                if (getTransactionList.fulfilled.match(result)) {
                    const transactionData = result?.payload?.data || [];
                    const total = transactionData.reduce((sum, item) => {
                        const amount = parseFloat(item.amount) || 0;
                        return sum + amount;
                    }, 0);
                    setTotalAmount(total);
                } else {
                    setTotalAmount(0);
                }
            } catch (error) {
                setTotalAmount(0);
            }
        };

        fetchTotalAmount();
    }, [dateRange, selectedProvider, dispatch]);

    const columns = [
        {
            title: 'User Name',
            dataIndex: 'user_name',
            key: 'user_name',
        },
        {
            title: 'Provider Name',
            dataIndex: 'provider_name',
            key: 'provider_name',
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            render: (amount) => amount ? `$${amount}` : '-',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
        },
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
        }
    ];

    const viewData = async (id) => {
        navigate(`/admin/user/${id}`)
    }

    const handleDateChange = (dates) => {
        setDateRange(dates);
    }

    const handleProviderChange = (value) => {
        setSelectedProvider(value);
    }

    // Prepare provider options from the providers list
    const providerOptions = providersList?.data?.map((provider) => ({
        label: `${provider.first_name || ''} ${provider.last_name || ''}`.trim() || provider.email,
        value: provider.id || provider.key
    })) || [];

    return (
        <>
            <AdminSidebar renderContent={
                <Card
                    title="Transactions"
                    style={{ marginBottom: 24 }}
                >
                    <Space style={{ marginBottom: 16 }}>
                        <RangePicker
                            onChange={handleDateChange}
                            allowClear
                            format="YYYY-MM-DD"
                        />
                        <Select
                            placeholder="Select Provider"
                            allowClear
                            style={{ width: 200 }}
                            onChange={handleProviderChange}
                            value={selectedProvider}
                            options={providerOptions}
                        />
                    </Space>
                    <TableComponent
                        listData={getTransactionList}
                        columns={columns}
                        showSearch={false}
                        dateFilter={dateRange}
                        providerFilter={selectedProvider}
                        totalAmount={totalAmount}
                        showTotalAmount={true}
                    />
                </Card>
            } />

        </>
    );
}

export default TransactionList;